import type { LocaleBundle } from "../types";

export const bundleIt: LocaleBundle = {
  locale: "it",
  config: {
    siteUrl: "https://ebuza.dev",
    name: "Enrico",
    surname: "Buza",
    nickname: "Moldaviano",
    role: "Sviluppatore Web",
    specialty: "Designer",
    about:
      "Sviluppatore full stack orientato al prodotto: backend solido, frontend curato, attenzione a sicurezza e performance. Progetti per PMI, e-commerce e applicazioni su misura.",
    aboutHeadline: "Codice che regge il business e interfacce che non ti fanno impazzire",
    aboutSubhead:
      "Sono Enrico Buza, sviluppatore web con forte impronta backend e sensibilità per UX e dettaglio. Aiuto team e clienti a passare da un’idea a un prodotto online affidabile, misurabile e pronto a crescere.",
    aboutStory: `Mi occupo di applicazioni web dove contano dati, integrazioni e chiarezza per chi le usa ogni giorno: da siti vetrina e landing ad e-commerce e piattaforme con dashboard e pagamenti.

Il mio percorso passa da Alloy S.r.l., dove lavoro sul backend (Node.js, TypeScript, microservizi, MySQL, Neo4j) con attenzione a privacy, sicurezza e performance. In parallelo coltivo il front-end con React e strumenti moderni, perché un’API ben fatta merita un’interfaccia che comunichi bene.

Ho esperienza sul campo con clienti reali, locali, retail, progetti su misura. So tradurre richieste vaghe in requisiti concreti, tempistiche realistiche e soluzioni che si possono mantenere nel tempo.`,
    aboutValueProps: [
      {
        title: "Stack serio, risultati concreti",
        description:
          "TypeScript, React, Node.js, SQL e grafi quando servono. Preferisco soluzioni semplici da evolvere a demo fragili che impressionano solo al primo colpo.",
      },
      {
        title: "Dal primo call al go-live",
        description:
          "Ti accompagno su analisi leggera, priorità, stima e iterazioni: utile sia se sei un cliente con un budget definito sia se sei un team che deve integrare una figura tecnica.",
      },
      {
        title: "Comunicazione chiara",
        description:
          "Aggiornamenti senza jargon inutile, documentazione dove serve e spazio per domande — così recruiter, PM e stakeholder sanno sempre a che punto siamo.",
      },
    ],
    aboutAvailability:
      "Aperto a opportunità lavorative in team strutturati e a collaborazioni su progetti freelance / siti e prodotti digitali. Scrivimi con ruolo o idea di progetto: rispondo con disponibilità e prossimi passi.",
    aboutQuickFacts: [
      { label: "Ruolo attuale", value: "Sviluppatore Web — Backend @ Alloy S.r.l." },
      { label: "Formazione", value: "Diploma IIS Levi Ponti, Mirano (VE) — 80/100" },
      { label: "Base", value: "Camposampiero (PD) · Italia" },
    ],
    social: {
      linkedin: "https://www.linkedin.com/in/enrico-buza-9b6992257/",
      github: "https://github.com/Moldaviano",
    },
    contactHeadline: "Costruiamo qualcosa di solido, insieme",
    contactSubhead:
      "Se sei un recruiter con una posizione, un imprenditore con un sito o un prodotto in mente, o un team che cerca una mano tecnica: scrivimi. Preferisco dialoghi concreti su obiettivi, tempi e modalità — niente trattative in sospeso.",
    contactHighlights: [
      {
        title: "Per chi assume",
        description:
          "Portfolio, GitHub e esperienza in azienda su backend e microservizi. Posso approfondire stack, modalità di lavoro e disponibilità in una mail o call breve.",
      },
      {
        title: "Per chi ha un progetto",
        description:
          "Da vetrina a piattaforme più strutturate: ti aiuto a capire cosa è realistico in fase uno, cosa può aspettare e come iterare senza sorprese.",
      },
      {
        title: "Cosa aspettarti",
        description:
          "Risposta strutturata, niente ghosting: se il progetto non è per me te lo dico, altrimenti ti propongo i prossimi passi chiari.",
      },
    ],
    contactFormHint:
      "Scrivi in poche righe cosa ti serve (es. «preventivo sito vetrina», «candidatura full stack», «collaborazione su API»): così capisco subito il contesto.",
    contactResponsePledge: "Di solito rispondo entro 1–2 giorni lavorativi.",
    phone: "+39 389 650 8459",
    locationDisplay: "Camposampiero (PD), Italia",
    projects: [
      {
        projectId: "1",
        title: "Pizzeria La Gustosa",
        description:
          "Realizzato sito web vetrina per la pizzeria La Gustosa, in questo momento sto implementando un sistema di ordinazioni online che include pagamenti sicuri tramite Stripe e gestione del menu, prodotti, prezzi, ingredienti etc.",
        url: "https://lagustosapizzeria.com/",
        clientName: "Pizzeria La Gustosa",
        technologies: ["React", "CSS", "Responsive Design"],
        references: "Aumento visualizzazioni online del 150% nei primi 3 mesi",
      },
      {
        projectId: "1",
        title: "Luxury Lounge Bar",
        description: "Sito di vetrina per un lounge bar. Ci sono diverse sezioni ma anche più pagine",
        url: "https://pub-showcase-0001.ebuza.dev//",
        imgUrl:
          "https://iad.microlink.io/qAjCxkS_jXkS9albFp2NMw2afZR6XKvQKMXqUcFBQ4yNIFvSqv6YEYkZBWVFQCZPaH5AdgJIMvtyn1LSVqntoA.png",
        clientName: "Pub Downtown",
        technologies: ["React", "TailwindCSS", "Framer Motion", "Vercel"],
        references: "Proprietario pub soddisfatto della presentazione online del locale",
      },
    ],
    experiences: [
      {
        id: "1",
        role: "Stage Formativo - Sviluppatore Web",
        company: "Alloy S.r.l.",
        description:
          "In questo mese di stage ho avuto l'opportunità di spaziare tra frontend e backend. Ho utilizzato AngularJS per creare un prototipo (POC) mirato a valutare l'impatto degli elementi grafici sulle prestazioni della pagina. Parallelamente, ho approfondito la parte backend lavorando con Node.js (TypeScript) su un framework proprietario, dove ho apportato modifiche a funzionalità integrate in un'architettura a microservizi.",
        startDate: "Giugno 2022",
        endDate: "Giugno 2022",
        location: "Mirano (VE), Italia",
        icon: "💻",
        achievements: [
          "Apprendimento di Node.js",
          "Apprendimento di AngularJS",
          "Lavorato su struttura a microservizi",
          "Implementazione di POC per testare le performance delle pagine",
        ],
      },
      {
        id: "2",
        role: "Stage Formativo Erasmus - Sviluppatore Wordpress/Shopify",
        company: "El Garbo de Greta",
        description:
          "Durante lo stage ho lavorato all'ottimizzazione di due siti web. Su WordPress, ho apportato modifiche strutturali al sito vetrina di un'agenzia di digital marketing e servizi Airbnb. Su Shopify, ho potenziato un e-commerce di abbigliamento implementando nuovi filtri di ricerca e gestendo l'aggiornamento del catalogo prodotti, migliorando così la fruibilità dello store digitale.",
        startDate: "Luglio 2022",
        endDate: "Agosto 2022",
        location: "Siviglia (ES), Spagna",
        icon: "🚀",
        achievements: [
          "Apprendimento di Wordpress",
          "Apprendimento di Shopify",
          "Implementazione di filtri su e-commerce",
        ],
      },
      {
        id: "3",
        role: "Sviluppatore Web - Backend",
        company: "Alloy S.r.l.",
        description:
          "In questo ruolo ho lavorato come Backend Developer utilizzando diverse tecnologie tra cui Node.js (TypeScript), MySQL e Neo4J. Ho imparato a lavorare su diversi framework proprietari, tutti basati su struttura a microservizi, e a implementare best practices per il backend prestando particolare attenzione a privacy e sicurezza degli utenti oltre che alle performance delle varie applicazioni.",
        startDate: "Agosto 2023",
        endDate: "Presente",
        location: "Mirano (VE), Italia",
        icon: "🎓",
        achievements: [
          "Completato corso interno di formazione React",
          "Contribuito allo sviluppo di 8 progetti",
          "Certificazione JavaScript Level 1",
        ],
      },
    ],
    email: "enrico.buza@ebuza.dev",
    skills: ["Typescript", "Javascript", "HTML5", "CSS", "TailwindCSS", "React", "SQL", "Neo4J", "MongoDB"],
    professionalServiceName: "Sviluppo siti web, API e prodotti digitali",
    professionalServiceDescription:
      "Servizi di sviluppo web full stack per PMI e team: siti vetrina, e-commerce, backend Node.js e frontend React/TypeScript.",
    countryServed: "Italia",
    metaSiteBrandSuffix: "Portfolio professionale",
  },
  certificates: [
    {
      title: "Introduction to Packet Tracer",
      imgUrl: "/ciscoIntroductionToPacketTracerCertificate.png",
      description:
        "Certificato di completamento del corso Introduction to Packet Tracer della Cisco Networking Academy.",
      category: "Networking",
      organization: "Cisco",
      date: "2022",
      credentialId: "",
    },
    {
      title: "Introduction to Cybersecurity",
      imgUrl: "/ciscoIntroductionToCybersecurityCertificate.png",
      description:
        "Certificato di completamento del corso Introduction to Cybersecurity della Cisco Networking Academy, dimostrando la capacità di comprendere minacce informatiche, vulnerabilità delle reti e strategie di difesa.",
      category: "Cybersecurity",
      organization: "Cisco",
      date: "2022",
      credentialId: "",
    },
    {
      title: "Cisco Cybersecurity Scholarship 2021/2022",
      imgUrl: "/ciscoScolarshipCertificate.png",
      description:
        "Attestato di partecipazione per aver frequentato e completato il percorso Cisco Cybersecurity Scholarship Italia 2021/2022.",
      category: "Cybersecurity",
      organization: "Cisco",
      date: "2022",
      credentialId: "",
    },
    {
      title: "NDG Linux Essentials",
      imgUrl: "/ndgLinuxEssentialsCertificate.png",
      description:
        "Certificato di completamento del corso NDG Linux Essentials presso la Cisco Networking Academy, preparazione per la certificazione Linux Essentials Professional Development.",
      category: "Sistema Operativo",
      organization: "Cisco",
      date: "2022",
      credentialId: "",
    },
    {
      title: "HTML Level 1",
      imgUrl: "/htmlLv1CCACertificate.png",
      description:
        "Certificato di qualificazione di livello 1 in HTML, rilasciato dalla Cambridge Certification Authority.",
      category: "Sviluppo Web",
      organization: "Cambridge Certification Authority",
      date: "2021",
      credentialId: "",
    },
    {
      title: "CSS Level 1",
      imgUrl: "/cssLv1CCACertificate.png",
      description:
        "Certificato di qualificazione di livello 1 in CSS, rilasciato dalla Cambridge Certification Authority.",
      category: "Sviluppo Web",
      organization: "Cambridge Certification Authority",
      date: "2021",
      credentialId: "",
    },
    {
      title: "Javascript Level 1",
      imgUrl: "/javascriptLv1CCACertificate.png",
      description:
        "Certificato di qualificazione di livello 1 in Javascript, rilasciato dalla Cambridge Certification Authority.",
      category: "Sviluppo Web",
      organization: "Cambridge Certification Authority",
      date: "2021",
      credentialId: "",
    },
  ],
  seoByPath: {
    "/": {
      title: "Enrico Buza | Sviluppatore web full stack — siti e API in Italia",
      description:
        "Sviluppatore web full stack in Veneto: React, TypeScript, Node.js, siti vetrina, e-commerce e backend su misura per PMI e team. Portfolio, progetti e contatti.",
    },
    "/about": {
      title: "Chi sono | Enrico Buza — sviluppatore web & backend",
      description:
        "Profilo di Enrico Buza: esperienza backend e frontend, metodo di lavoro con clienti e team, stack TypeScript e collaborazioni in Italia e da remoto.",
    },
    "/projects": {
      title: "Progetti web | Portfolio siti e case study — Enrico Buza",
      description:
        "Selezione di progetti web reali: siti vetrina, lounge bar, integrazioni e stack React, Tailwind e deploy. Anteprime live e referenze clienti.",
    },
    "/skills": {
      title: "Competenze | React, TypeScript, Node.js, SQL — Enrico Buza",
      description:
        "Competenze tecniche: frontend React, backend Node.js, database SQL e grafi, tooling Git e Linux. Orientamento a performance, sicurezza e manutenibilità.",
    },
    "/certificates": {
      title: "Certificati Cisco e sviluppo web | Formazione — Enrico Buza",
      description:
        "Certificazioni Cisco Networking Academy, cybersecurity e attestati HTML/CSS/JavaScript. Trasparenza sul percorso di formazione professionale.",
    },
    "/contact": {
      title: "Contatti | Preventivo sito web, collaborazioni — Enrico Buza",
      description:
        "Contatta Enrico Buza per un preventivo sito web, progetto freelance o opportunità lavorative. Email, telefono, risposta in 1–2 giorni lavorativi.",
    },
  },
  ui: {
    nav: [
      { id: "home", label: "Home", path: "/" },
      { id: "projects", label: "Progetti", path: "/projects" },
      { id: "about", label: "Chi sono", path: "/about" },
      { id: "skills", label: "Competenze", path: "/skills" },
      { id: "certificates", label: "Certificati", path: "/certificates" },
      { id: "contatti", label: "Contatti", path: "/contact" },
    ],
    navAriaMain: "Navigazione principale",
    navOpenMenu: "Apri menu",
    navCloseMenu: "Chiudi menu",
    navMobileSection: "Navigazione",
    hero: {
      kicker: "Sviluppo web · Full stack ·",
      titleGradient: "Siti e prodotti digitali che reggono il traffico",
      lead: "TypeScript, React e Node per chi vuole un sito veloce, un e-commerce che converte o un backend ordinato. Lavoro con PMI, locali e team: dalla prima call al go-live, senza sorprese.",
      ctaPrimary: "Parliamo del tuo progetto",
      ctaSecondary: "Vedi i progetti",
      cardClientsTitle: "Per clienti",
      cardClientsBody:
        "Preventivi chiari, stack moderno e codice che puoi far evolvere. Ideale se ti serve un sito vetrina, un restyling o integrazioni con pagamenti e gestionali.",
      cardRecruiterTitle: "Per recruiter",
      cardRecruiterBody:
        "Esperienza in azienda su backend e microservizi, React sul front e attenzione a sicurezza e performance.",
      cardRecruiterLink: "Profilo e percorso →",
      stackLine: "stack — React · TypeScript · Node · SQL · Neo4j",
    },
    about: {
      badge: "Per recruiter, team e clienti",
      mailSubject: "Contatto dal portfolio",
      ctaProject: "Progetto o candidatura",
      portraitAlt: "Ritratto",
      summaryHeading: "In sintesi",
      storyHeading: "Perché lavorare con me",
      valuesSrOnly: "Cosa porto nei progetti",
      formCta: "Form contatti",
    },
    contact: {
      badge: "Contatti",
      linkAbout: "Chi sono",
      linkProjects: "Progetti",
      whyHeading: "Cosa trovi scrivendomi",
      directChannels: "Canali diretti",
      emailLabel: "Email",
      phoneLabel: "Telefono",
      locationLabel: "Posizione",
      socialHeading: "Social",
      formTitle: "Invia un messaggio",
      nameLabel: "Nome",
      namePlaceholder: "Il tuo nome o azienda",
      emailPlaceholder: "tua@email.it",
      messageLabel: "Messaggio",
      messagePlaceholder: "Es. tipo di progetto, tempistiche, stack richiesto…",
      submit: "Invia messaggio",
      submitting: "Invio in corso…",
      validationRequired: "Compila tutti i campi.",
      successMessage: "Messaggio inviato. Ti rispondo al più presto.",
      errorPrefix: "Errore:",
    },
    projects: {
      badge: "Casi studio",
      title: "Progetti web",
      intro:
        "Siti in produzione e lavori su misura. Le anteprime si aggiornano con le API Microlink (screenshot e metadati della pagina live).",
      previewUnavailable: "Anteprima non disponibile",
      previewLiveUnavailable: "Anteprima live non disponibile",
      openSiteAria: "Apri il sito in una nuova scheda",
      visitSite: "Visita il sito",
      cardAlt: "Anteprima sito web:",
    },
    skills: {
      badge: "Stack & tooling",
      title: "Competenze",
      intro:
        "Tecnologie che uso in produzione ogni giorno, ordinate per area, come in un vero codebase.",
      categories: [
        {
          title: "Frontend",
          skills: [
            { name: "React" },
            { name: "TypeScript" },
            { name: "Tailwind CSS" },
            { name: "HTML5" },
          ],
        },
        {
          title: "Backend",
          skills: [{ name: "Node.js" }, { name: "Express" }, { name: "MongoDB" }, { name: "MySQL" }],
        },
        {
          title: "Tooling",
          skills: [{ name: "Git" }, { name: "VS Code" }, { name: "Linux" }, { name: "Vercel" }],
        },
      ],
      closing:
        "Preferisco stack TypeScript end-to-end, API chiare e deploy ripetibili. Se serve integrazione pagamenti, SEO tecnica o performance: si parla in fase di analisi.",
      closingCode: 'import { focus } from "business"',
    },
    certificates: {
      badge: "Formazione continua",
      title: "Certificati",
      intro: "Networking, cybersecurity e fondamenti di sviluppo web.",
      filterAll: "Tutti",
      statCerts: "Certificati",
      statOrgs: "Enti",
      statAreas: "Aree",
    },
    footer: {
      tagline: "Sviluppo web full stack — Italia.",
      navAria: "Collegamenti nel sito",
    },
    certificateCard: {
      alt: "Certificato",
      altFullscreen: "Certificato a tutto schermo:",
      verify: "Verifica certificato",
    },
  },
};
